import React, { ComponentPropsWithRef } from 'react'

import { TextInput as BaseTextInput } from '@style-port/roov-ui-components-react'

type TextInputProps = ComponentPropsWithRef<typeof BaseTextInput>
type Props = TextInputProps & {
  hasError?: boolean
}

export const TextInput = React.forwardRef<HTMLInputElement, Props>(
  ({ hasError, state, ...otherProps }, ref) => {
    const stateProperty = hasError ? 'error' : state

    return <BaseTextInput state={stateProperty} {...otherProps} ref={ref} />
  }
)
